import { Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { NoteUpd } from '../../models/NoteUpd';
import { ConfirmOutput } from '../../models/ConfirmOutput';
import { CPDialogResult } from '../../enums/CPDialogResult';
import { CRUDActions } from '../../enums/CRUDActions';
import { CommonFunctions } from '../../static/common-functions';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { MessageInfo } from '../../models/MessageInfo';
import { GlobalsService } from '../../services/globals.service';
import { MessageInfoType } from '../../enums/MessageInfoType';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
    selector: 'message-info-dialog',
    templateUrl: './message-info-dialog.component.html',
    styleUrls: ['./message-info-dialog.component.scss'],
    standalone: false
})
export class MessageInfoDialogComponent  {

    constructor(globals: GlobalsService) {

    }
    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
    showAll: boolean = false;
    active: boolean = false;
    data: any;
    gridData: MessageInfo[];
    action: CRUDActions;
    title: string;
    message: string;
    code: string;
    okButtonShow: boolean = true;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();

    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action = CRUDActions.None;
    }
    ok() {
        let result: ConfirmOutput = { action: this.action,  dialogResult: CPDialogResult.ok, data: this.data, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(message: string, info: BaseMessageInfo, data: any = null, title: string = null, code = null, okButtonText = "Ok", type: MessageInfoType = MessageInfoType.general) {
        this.data = data;
        this.action = null;

        this.title = CommonFunctions.getStringValueIfNull(title, "Please Confirm");
        this.message = message;
        this.code = code;
        if (type === MessageInfoType.confirm) {
            this.gridData = info.messages.filter(s => s.messageType === MessageInfoType.confirm);
        }
        else {
            this.gridData = info.messages.filter(s => s.messageType !== MessageInfoType.confirm);
        }
//        this.gridData = info.messages;
        this.active = true;
        this.okButtonText = "Ok";
        if (CommonFunctions.hasStringValue(okButtonText)) {
            this.okButtonText = okButtonText;
            this.okButtonShow = true;
        }
        else {
            this.okButtonShow = false;
        }
    }
    okButtonText: string = "Ok"
    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

}

